import { LocationType } from "@/types/business/location.type";
import { LocationInterface } from "@/interface/business/location.interface";
import { ExtraCharge } from "@/modules/business/extra-charges";

export default class Location implements LocationInterface {
  address: string = "";
  footer: any = null;
  has_kds: boolean = false;
  id: string = "";
  image: any = null;
  name: string = "";
  payment_methods: Array<any> = [];
  phone: string = "";
  position: any = null;
  profile: any = null;
  registers: Array<any> = [];
  required_permissions: Array<any> = [];
  tax_number: number | null = null;
  selected: boolean = true;
  charges?: Array<any> = [];

  constructor(data?: LocationType) {
    if (data) {
      this.address = data.address;
      this.footer = data.footer;
      this.has_kds = data.has_kds;
      this.id = data.id;
      this.name = data.name;
      this.image = data.image;
      this.payment_methods = data.payment_methods;
      this.profile = data.profile;
      this.registers = data.registers;
      this.required_permissions = data.required_permissions;
      this.tax_number = data.tax_number;
      this.phone = data.phone;
      this.charges = data?.charges?.map((charge) => new ExtraCharge(charge)) || [];
    }
  }
}
